import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    width: ['100%', 'initial'],
    alignItems: ['center', 'flex-start'],
    flexDirection: ['column', 'row'],
    '@media screen and (max-width: 1023px)': {
      '&:not(:first-of-type)': {
        marginTop: '40px',
      },
    },
  },
  avatar: {
    marginBottom: ['24px', '0px'],
  },
  informationContainer: {
    paddingTop: [null, '40px'],
    color: 'black.100',
    textAlign: 'left',
    maxWidth: [null, '200px', '200px', '260px', '305px'],
    marginLeft: [null, '20px', '20px', '40px', '60px'],
  },
  informationAuthorName: {
    marginBottom: ['0px', '4px'],
  },
  informationAuthorPosition: {},
  informationAuthorCompany: {
    marginBottom: ['10px', '14px'],
  },
  informationAuthorDescription: {},
};
